module.exports = __webpack_public_path__ + "img/fig15.5010df95.jpg";